import { CSSObject } from '@mantine/core'

const SIZES = {
    h1: {
        fontSize: '3.4rem'
    },
    h2: {
        fontSize: '2.6rem'
    },
    h3: {
        fontSize: '2.2rem'
    },
    h4: {
        fontSize: '1.8rem'
    },
    h5: {
        fontSize: '1.6rem'
    },
    h6: {
        fontSize: '1.4rem'
    }
}

export const getTitleStyles = (element: string): Record<string, CSSObject> => {
    const style = SIZES[element] || {}

    return {
        root: {
            ...style
        }
    }
}
